import { Gateway } from '../../../../shared/api/gateway/Gateway';
import { IVehicle } from '../../../../shared/api/gateway/models/Vehicle';
import { PostAddVehicleRequest } from '../../../../shared/api/gateway/types/vehicle';

export type ILoaderAddVehicle = (
	data: PostAddVehicleRequest,
) => Promise<IVehicle>;

export function addVehicleLoader(api: Gateway): ILoaderAddVehicle {
	return async (data) => {
		const vehicle = await api.vehicle().addVehicle(data);
		return vehicle;
	};
}
